import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_EN_TRANSITO } from '../../../../../config/tables'

export function ListadoCamionesEnTransitoDetalleView () {
  return <MuiTable id={TABLA_CAMIONES_EN_TRANSITO} />
}
